import { buildInvoiceReceiptNumber } from "./invoice";

/**
 * Check if site is Makro site
 * @param {str} clientID
 * @returns
 */
export const isMakroSite = (clientID) => clientID == 18;

/**
 * Check if site is a free site
 * @param {array} discountArr
 * @returns if its a free site
 */
export const isFreeSite = (discountArr) =>
	discountArr.every((discount) => discount == 0);

/**
 * Get invoice number of Makro sites
 * @param {str} siteCode
 * @param {str} yearMonth
 * @returns
 */
export const getMakroInvoiceNo = (siteCode, date) => {
	const MKcode =
		siteCode.length === 5 ? siteCode.substr(0, 3) : siteCode.substr(0, 4);

	const invNo = buildInvoiceReceiptNumber({ type: 'INV', solarEntityId: 'S1', siteCode: MKcode, date });
	return invNo;
};
